import { Container, Graphics, Text } from "pixi.js";
import type { SafeArea, Scene, Size } from "./engine";

const BAR_HEIGHT = 12;

/** Minimal progress bar shown while asset bundles load, with a status line below it. */
export class LoadingScene implements Scene {
  readonly view = new Container();
  private readonly track = new Graphics();
  private readonly fill = new Graphics();
  private readonly status = new Text({
    text: "",
    style: { fill: "#c0c4d6", fontSize: 18, align: "center", wordWrap: true, wordWrapWidth: 320 },
  });
  private barWidth = 0;
  private progress = 0;
  private requestRender: () => void = () => {};

  constructor() {
    this.status.anchor.set(0.5, 0);
    this.view.addChild(this.track, this.fill, this.status);
  }

  attach(requestRender: () => void): void {
    this.requestRender = requestRender;
  }

  setProgress(progress: number): void {
    this.progress = Math.min(1, Math.max(0, progress));
    this.draw();
  }

  setStatus(text: string): void {
    this.status.text = text;
    this.requestRender();
  }

  layout(size: Size, _safe: SafeArea): void {
    this.barWidth = Math.min(size.width * 0.6, 320);
    this.view.position.set((size.width - this.barWidth) / 2, (size.height - BAR_HEIGHT) / 2);
    this.status.position.set(this.barWidth / 2, BAR_HEIGHT + 20);
    this.status.style.wordWrapWidth = Math.max(this.barWidth, Math.min(size.width - 32, 420));
    this.draw();
  }

  private draw(): void {
    const radius = BAR_HEIGHT / 2;
    this.track.clear().roundRect(0, 0, this.barWidth, BAR_HEIGHT, radius).fill("#2e3247");
    this.fill.clear();
    if (this.progress > 0) {
      const width = Math.max(BAR_HEIGHT, this.barWidth * this.progress);
      this.fill.roundRect(0, 0, width, BAR_HEIGHT, radius).fill("#ffd166");
    }
    this.requestRender();
  }
}
